export default {
  name: 'drawer',
  component(_settings) {
    return {
      // Stack of panel IDs — last item is the active (visible) panel
      panelStack: ['root'],

      init() {
        // Lock body scroll whenever this drawer element is visible.
        // Use a MutationObserver to watch for display changes driven by the
        // parent section's x-show (e.g. the sidebar drawer toggling).
        this._observer = new MutationObserver(() => {
          const hidden = this.$el.closest('[x-show]')
            ? this.$el.closest('[x-show]').style.display === 'none'
            : this.$el.style.display === 'none';
          document.body.style.overflow = hidden ? '' : 'hidden';
        });

        this._observer.observe(this.$el, { attributes: true, attributeFilter: ['style'] });

        const parentShowEl = this.$el.closest('[x-show]');
        if (parentShowEl) {
          this._observer.observe(parentShowEl, { attributes: true, attributeFilter: ['style'] });
        }

        // Also unlock on close-drawer event
        this.$el.addEventListener('close-drawer', () => {
          document.body.style.overflow = '';
        });
      },

      destroy() {
        if (this._observer) this._observer.disconnect();
        document.body.style.overflow = '';
        document.body.classList.remove('submenu-open');
      },

      get activePanel() {
        return this.panelStack[this.panelStack.length - 1];
      },

      navigateTo(panelId) {
        this.panelStack.push(panelId);
        document.body.classList.add('submenu-open');
      },

      navigateBack() {
        if (this.panelStack.length > 1) {
          this.panelStack.pop();
        }
        if (this.panelStack.length === 1) {
          document.body.classList.remove('submenu-open');
        }
      },

      isActive(panelId) {
        return this.activePanel === panelId;
      },
    };
  },
};
